export default __webpack_public_path__ + "static/media/Long Life logo.0ad6f2cb.png";